/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightCheckoutError
 */
export interface FlightCheckoutError {
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutError
     */
    code: FlightCheckoutErrorCodeEnum;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutError
     */
    message: string;
}


/**
 * @export
 */
export const FlightCheckoutErrorCodeEnum = {
    Forbidden: 'forbidden',
    NotFound: 'not_found',
    InvalidRequest: 'invalid_request',
    IdempotencyConflict: 'idempotency_conflict',
    QuoteConflict: 'quote_conflict',
    QuoteExpired: 'quote_expired',
    CheckoutDisabled: 'checkout_disabled',
    TemporarilyUnavailable: 'temporarily_unavailable'
} as const;
export type FlightCheckoutErrorCodeEnum = typeof FlightCheckoutErrorCodeEnum[keyof typeof FlightCheckoutErrorCodeEnum];


/**
 * Check if a given object implements the FlightCheckoutError interface.
 */
export function instanceOfFlightCheckoutError(value: object): value is FlightCheckoutError {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function FlightCheckoutErrorFromJSON(json: any): FlightCheckoutError {
    return FlightCheckoutErrorFromJSONTyped(json, false);
}

export function FlightCheckoutErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCheckoutError {
    if (json == null) {
        return json;
    }
    return {

        'code': json['code'],
        'message': json['message'],
    };
}

export function FlightCheckoutErrorToJSON(json: any): FlightCheckoutError {
    return FlightCheckoutErrorToJSONTyped(json, false);
}

export function FlightCheckoutErrorToJSONTyped(value?: FlightCheckoutError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'code': value['code'],
        'message': value['message'],
    };
}
